﻿// New public features use ES modules; legacy globals are loaded first by the build adapter.
import '../entries/booking-link-internal.js';

import './widgets.scss';
